// @ts-nocheck
import {
  useMutationEngine,
  useNewQueryEngine,
} from '../../../queries/useDataEngine';
import { EMPTY_OBJECT } from '../../../const/CommonConst';
import { DashboardService } from './dashboardService';

const DASHBOARD = 'dashboard';

export const DASHBOARD_QUERY_KEYS = {
  ALL: [DASHBOARD],

  allSavedSearches: {
    ROOT: [DASHBOARD, 'allSavedSearches'],
    key: (params = {}) => [DASHBOARD, 'allSavedSearches', params],
  },

  alertData: {
    ROOT: [DASHBOARD, 'alertData'],
    key: (params = {}) => [DASHBOARD, 'alertData', params],
  },

  pipelineData: {
    ROOT: [DASHBOARD, 'pipelineData'],
    key: (params = {}) => [DASHBOARD, 'pipelineData', params],
  },

  kibanDashboard: {
    ROOT: [DASHBOARD, 'kibanDashboard'],
    key: (params = {}) => [DASHBOARD, 'kibanDashboard', params],
  },
};

export const useAllSavedSearchesQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    DASHBOARD_QUERY_KEYS.allSavedSearches.key,
    DashboardService.getAllSavedSearches,
    params,
    options
  );

export const useAlertDataQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    DASHBOARD_QUERY_KEYS.alertData.key,
    DashboardService.getAlertData,
    params,
    options
  );

export const usePipelineDataQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    DASHBOARD_QUERY_KEYS.pipelineData.key,
    DashboardService.getPipelineData,
    params,
    options
  );

export const useKibanDashboardQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    DASHBOARD_QUERY_KEYS.kibanDashboard.key,
    DashboardService.getKibanDashboard,
    params,
    options
  );

export const useDownloadConnectivityReportMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useMutationEngine(DashboardService.downloadConnectivityReport, options);
